import SearchFilter from '../../../components/filters/SearchFilter';
import { Grid } from '@mui/material';
import React from 'react';

const ProductsListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
}) => {
  const renderFilter = (filter) => {
    switch (filter.type) {
      case 'search':
        return (
          <SearchFilter
            key={filter.type}
            filter={filter}
            selectedFilter={selectedFilter}
            onFilterChange={onFilterChange}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            onSearchKeyPress={onSearchKeyPress}
          />
        );
      default:
        return null;
    }
  };
  return (
    <Grid size={{ xs: 12 }} sx={{ padding: '2px' }} container justifyContent="flex-end" alignItems="center" spacing={1}>
      {filters.map((filter) => renderFilter(filter))}
    </Grid>
  );
};

export default ProductsListFilters;
